export const PRODUCT_GROUP = {
  TKS: 1,
  OPS: 2,
  HPS: 3,
};

export const PRODUCT = {
  TKS24: "TKS24",
  TKS: "TKS",
  TKSE: "TKSE",
  OPS24: "OPS24",
  OPS: "OPS",
  OPSE: "OPSE",
  HPS24: "HPS24",
  HPS: "HPS",
  HPSE: "HPSE",
};

export const PET_TYPE = {
  DOG: 1,
  CAT: 2,
};
